import { Observable , Subject} from 'rxjs'
import { StepProps } from './step-props';
import {Injector} from '@angular/core';
import { IStepWizardStates } from '../IStepWizardStates';

export abstract class ACustomStepWizard <T> {
  public stepName: string;
  public props: StepProps;
  public dataNotifier: Subject<any>;
  public stepNotifier: Subject<any>;
  public data: T = {} as T;
  public state: IStepWizardStates;
  public id: number;
  abstract isValid(): Observable<boolean>;

  constructor(stepName: string) {
    this.stepName = stepName;
    this.state = {
      active: false,
      completed: false
    }
  }

  protected updateData(key: string, data: any) {
    this.dataNotifier.next({[key]: data});
  }

  public load() {}
  public canGoNext(): boolean {
    return true;
  };

  public setProperties(injector: Injector) {
    this.dataNotifier = injector.get('dataNotifier');
    this.stepNotifier = injector.get('stepNotifier');
    this.data = _.extend(this.data, injector.get('data'));
    this.dataNotifier.subscribe((data: {[key: string]: any}) => {
     this.data = _.extend(this.data, data);
    });
  }

  public setActive() {
    this.load();
    this.state = {
      completed: false,
      active: true
    };
  }

  public setCompleted() {
    this.state = {
      completed: true,
      active: false
    };
  }

  public clearState() {
    this.state = {
      active: false,
      completed: false
    };
  }

  public goToStep(index: number) {
    this.stepNotifier.next({navigate: index})
  }
}
